import React, { useState } from 'react';
import { Modal, Input, Button, Form, Alert, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const { Title } = Typography;

const PasswordOverlay = ({ visible, onAuthenticate }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);
    setError(false);
    
    setTimeout(() => {
      const success = onAuthenticate(password);
      if (!success) {
        setError(true);
        setPassword('');
      }
      setLoading(false);
    }, 300);
  };

  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      maskClosable={false}
      centered
      width={400}
      bodyStyle={{ padding: '40px' }}
      maskStyle={{
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(0, 0, 0, 0.6)'
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <LockOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '20px' }} />
        <Title level={3} style={{ margin: 0 }}>Authentication Required</Title>
      </div>

      <Form onFinish={handleSubmit}>
        <Form.Item>
          <Input.Password
            size="large"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onPressEnter={handleSubmit}
            autoFocus
          />
        </Form.Item>

        {error && (
          <Alert
            message="Incorrect password"
            type="error"
            showIcon
            style={{ marginBottom: '16px' }}
          />
        )}

        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={loading}
            disabled={!password}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PasswordOverlay;